var MobileAppWSDriver = /** @class */ (function () {
    function MobileAppWSDriver() {
        var _this = this;
        this.handleMessage = function (message) {
            var _a, _b, _c, _d;
            switch (message.type) {
                case 'open':
                    (_a = _this.onopen) === null || _a === void 0 ? void 0 : _a.call(_this, message.event);
                    break;
                case 'close':
                    (_b = _this.onclose) === null || _b === void 0 ? void 0 : _b.call(_this, message.event);
                    break;
                case 'error':
                    (_c = _this.onerror) === null || _c === void 0 ? void 0 : _c.call(_this, message.event);
                    break;
                case 'message':
                    (_d = _this.onmessage) === null || _d === void 0 ? void 0 : _d.call(_this, message.event);
                    break;
            }
        };
        this.socketUnsubscribe =
            MobileAppWSDriver.mobileAppService.onSocketEvent(this.handleMessage);
        setTimeout(function () { var _a; return (_a = _this.onopen) === null || _a === void 0 ? void 0 : _a.call(_this); });
    }
    MobileAppWSDriver.prototype.close = function () {
        var _a, _b;
        (_a = this.socketUnsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.onclose) === null || _b === void 0 ? void 0 : _b.call(this);
    };
    MobileAppWSDriver.prototype.send = function (data) {
        var _a;
        // Noop. Web wrapper will handle user topic subscriptions.
        // WS send not used for anything else.
        // Just provide inmmediate response to avoid leaving pending requests
        try {
            var message = JSON.parse(data);
            var event_1 = new MessageEvent('app-ws-driver', {
                data: JSON.stringify({
                    id: message.id,
                    payload: {},
                }),
            });
            (_a = this.onmessage) === null || _a === void 0 ? void 0 : _a.call(this, event_1);
        }
        catch (error) {
            console.error('[WS APP DRIVER] Error trying to send', error);
        }
    };
    return MobileAppWSDriver;
}());

export { MobileAppWSDriver };
